import axios from "../utils/axios";

// ==========================================
// Admin Orders
// ==========================================

export const getOrders = async (params) => {
    const response = await axios.get("/admin/orders", { params });
    return response.data;
};

export const getOrderById = async (id) => {
    const response = await axios.get(`/admin/orders/${id}`);
    return response.data;
};

export const createOrder = async (data) => {
    const response = await axios.post("/admin/orders", data);
    return response.data;
};

export const updateOrder = async (id, data) => {
    const response = await axios.put(`/admin/orders/${id}`, data);
    return response.data;
};

export const updateOrderStatus = async (id, data) => {
    const response = await axios.put(`/admin/orders/${id}/status`, data);
    return response.data;
};

export const bulkUpdateOrderStatus = async (data) => {
    const response = await axios.post("/admin/orders/bulk-status", data);
    return response.data;
};

export const refundOrder = async (id, data) => {
    const response = await axios.post(`/admin/orders/${id}/refund`, data);
    return response.data;
};

export const getOrderTimeline = async (id, params) => {
    const response = await axios.get(`/admin/orders/${id}/timeline`, { params });
    return response.data;
};

// Order Notes

export const getOrderNotes = async (id) => {
    const response = await axios.get(`/admin/orders/${id}/notes`);
    return response.data;
};

export const createOrderNote = async (id, data) => {
    const response = await axios.post(`/admin/orders/${id}/notes`, data);
    return response.data;
};

export const deleteOrderNote = async (id, noteId) => {
    const response = await axios.delete(`/admin/orders/${id}/notes/${noteId}`);
    return response.data;
};
